import React, { useEffect, useState, useRef } from 'react';
import { CircularProgress, Typography } from '@material-ui/core';
import { useSnackbar } from 'notistack';

const AudioContent = ({
  auth,
  audioPaths,
  handlePause,
  handlePlay,
  booking
}) => {
  const [audioSrc, setAudioSrc] = useState(null);
  const [loading, setLoading] = useState(false);
  const audioRefs = useRef([]);
  const currentlyPlayingIndex = useRef(null); // Track currently playing audio
  const snackbar = useSnackbar();
  useEffect(() => {
    const fetchAudioResources = async () => {
      if (audioPaths && audioPaths.length > 0) {
        setLoading(true);
        try {
          const audios = await auth.api.materials.GetAudioResources(audioPaths);
          setAudioSrc(audios);
        } catch (error) {
          console.error('Error fetching audio resources:', error);
          setAudioSrc(null);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchAudioResources();
  }, [audioPaths?.length, audioPaths, auth?.role]);

  const getFileName = (url) => {
    const cleanUrl = url.split('?')[0];
    const encodedPath = cleanUrl.split('/').pop();
    const decodedPath = decodeURIComponent(encodedPath);
    const fileName = decodedPath.split('/').pop();
    return fileName.length > 30 ? `${fileName.substring(0, 30)}...` : fileName;
  };

  const onPlay = async (index) => {
    // Pause previously playing audio
    if (
      currentlyPlayingIndex.current !== null &&
      currentlyPlayingIndex.current !== index
    ) {
      const prevAudio = audioRefs.current[currentlyPlayingIndex.current];
      if (prevAudio && !prevAudio.paused) {
        prevAudio.pause();
      }
    }

    const currentAudio = audioRefs.current[index];
    currentlyPlayingIndex.current = index;

    // Call external handler
    if (currentAudio && typeof handlePlay === 'function') {
      await handlePlay(`audio-${index}`);
    }
  };

  const onPause = (index) => {
    const currentAudio = audioRefs.current[index];

    if (currentlyPlayingIndex.current === index && currentAudio?.paused) {
      currentlyPlayingIndex.current = null;
      if (typeof handlePause === 'function') {
        handlePause(audioRefs.current[index]);
        // Trigger pause function
      }
    }
  };

  return (
    <div>
      {loading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '20px'
          }}>
          <CircularProgress />
        </div>
      ) : audioSrc && audioSrc.length > 0 ? (
        audioSrc.map((aud, i) => (
          <div key={i}>
            <Typography variant="subtitle1" style={{ margin: '10px 0' }}>
              {getFileName(aud)}
            </Typography>
            <audio
              ref={(el) => (audioRefs.current[i] = el)}
              style={{ width: '100%' }}
              id={`audio-${i}`}
              src={aud}
              crossOrigin="anonymous"
              controls
              controlsList="nodownload"
              onPlay={(e) => {
                if (
                  typeof handlePlay === 'function' &&
                  auth.role === 'student'
                ) {
                  e.target.pause();
                  snackbar.enqueueSnackbar(
                    'You are not allowed to play audio',
                    {
                      variant: 'error'
                    }
                  );
                  return;
                }
                onPlay(i);
              }}
              onPause={() => onPause(i)}>
              <source src={aud} type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          </div>
        ))
      ) : (
        <Typography variant="body1">No audio available.</Typography>
      )}
    </div>
  );
};

export default AudioContent;
